import theme from 'components/theme';
import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';

export const PackImageContainer = styled.div`
  position: relative;
  width: 100%;
  grid-row: 1 / span 3;
  grid-column: 1 / 2;
  align-self: center;
  object-fit: contain;
  padding: 0 6px;

  ${mediaDesktop} {
    height: 100%;
    margin: 0 auto;
    padding: 0;
  }
`;

export const PackStickerWrapper = styled.div<{ isWithBackground?: boolean }>`
  position: absolute;
  width: ${({ isWithBackground }) => (isWithBackground ? ' 35%' : '45%')};
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: ${({ isWithBackground }) => (isWithBackground ? ' 22%' : '16%')};
  right: ${({ isWithBackground }) => (isWithBackground ? '27%' : '19%')};
`;

export const StickerContent = styled.div`
  position: absolute;
  top: 0;
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: rotateZ(-7deg);
`;

const Container = styled.div`
  position: absolute;
  max-width: 100%;
  height: 12px;
  line-height: 4px;
  font-size: 4px;
  font-family: ${theme.fonts.syncopate};
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaDesktop} {
    height: 18px;
    line-height: 6px;
    font-size: 6px;
  }
`;

export const Text = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  overflow-wrap: anywhere;
`;

export const CreatorContainer = styled(Container)`
  top: 26%;
`;

export const TitleContainer = styled(Container)`
  top: 70%;
`;

export const Image = styled.img`
  width: 100%;

  ${mediaDesktop} {
    height: auto;
  }
`;
